// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { EVENTS_LIST_WRAPPER } from './List.queries'

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
const ListWrapper = () => {
    const { data, loading } = useQuery(EVENTS_LIST_WRAPPER)

    if (loading) {
        return null
    }
    return <List data={data} />
}

const List = ({ data }) => {
    const { viewer, site } = data

    const { t } = useTranslation()

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        typeFilter: ['event'],
        showEventFilter: true,
        itemView: window.__SETTINGS__.eventTiles ? 'tile' : 'list',
        itemCount: window.__SETTINGS__.eventTiles ? 3 : 10,
    }

    useWindowScrollPosition('events')

    return (
        <>
            <PageHeader
                title={t('entity-event.name', { count: 2 })}
                canCreate={viewer?.canWriteToContainer}
                createLink="/events/add"
                createLabel={t('entity-event.create')}
            />
            <Section>
                <Container
                    size={window.__SETTINGS__.eventTiles ? 'large' : 'tiny'}
                >
                    <FeedView guid="events" settings={settings} />
                </Container>
            </Section>
        </>
    )
}

export default ListWrapper
